<section class="metricas" *ngIf="carregando || metricas">
  <header>
    <h3>Resultados dos últimos {{ metricas?.periodoDias || 30 }} dias</h3>
    <button type="button" class="alerta" *ngIf="metricas?.comecaramAEsfriar" (click)="chamar.emit()">
      <i class="fe-thermometer"></i>
      <span><b>{{ numero(metricas.comecaramAEsfriar) }}</b> {{ plural(metricas.comecaramAEsfriar, 'começou', 'começaram') }} a esfriar</span>
      <em>Chamar agora <i class="fe-arrow-right"></i></em>
    </button>
  </header>

  <div class="blocos" *ngIf="carregando">
    <div class="bloco esqueleto" *ngFor="let i of [1,2,3,4]"><span class="a"></span><span class="b"></span><span class="c"></span></div>
  </div>

  <div class="blocos" *ngIf="!carregando && metricas">
    <div class="bloco destaque">
      <span class="rotulo"><i class="fe-send"></i>Vendas depois de mensagens</span>
      <strong>{{ moeda(metricas.mensagens.receita) }}</strong>
      <p *ngIf="metricas.mensagens.contatos; else semMensagens">
        {{ numero(metricas.mensagens.clientesQuePediram) }} de {{ numero(metricas.mensagens.contatos) }}
        {{ plural(metricas.mensagens.contatos, 'cliente', 'clientes') }} pediram até {{ metricas.mensagens.janelaDias }} dias
        depois de uma campanha ou mensagem<ng-container *ngIf="metricas.mensagens.recuperados.clientes">,
        {{ moeda(metricas.mensagens.recuperados.receita) }} de quem estava sumido</ng-container>.
      </p>
      <ng-template #semMensagens><p>Nenhuma campanha ou mensagem de reativação no período.</p></ng-template>
    </div>

    <div class="bloco">
      <span class="rotulo"><i class="fe-rotate-ccw"></i>Voltaram a comprar</span>
      <strong>{{ numero(metricas.voltaram) }}</strong>
      <p>{{ plural(metricas.voltaram, 'cliente que estava', 'clientes que estavam') }} esfriando, {{ plural(metricas.voltaram, 'sumido', 'sumidos') }} ou {{ plural(metricas.voltaram, 'perdido', 'perdidos') }}.</p>
    </div>

    <div class="bloco">
      <span class="rotulo"><i class="fe-repeat"></i>Recompra em 90 dias</span>
      <strong>{{ metricas.recompra90.taxa === null ? '—' : metricas.recompra90.taxa + '%' }}</strong>
      <p *ngIf="metricas.recompra90.base">
        dos {{ numero(metricas.recompra90.base) }} que compraram há 3 a 6 meses voltaram a pedir.
      </p>
      <p *ngIf="!metricas.recompra90.base">Ainda sem pedidos de 3 a 6 meses atrás.</p>
    </div>

    <div class="bloco">
      <span class="rotulo"><i class="fe-clock"></i>Até o 2º pedido</span>
      <strong>{{ metricas.segundoPedido.mediaDias === null ? '—' : numero(metricas.segundoPedido.mediaDias) + (metricas.segundoPedido.mediaDias === 1 ? ' dia' : ' dias') }}</strong>
      <p *ngIf="metricas.segundoPedido.clientes">
        em média, para os {{ numero(metricas.segundoPedido.clientes) }} que fizeram o 2º pedido nos últimos 6 meses.
      </p>
      <p *ngIf="!metricas.segundoPedido.clientes">Ninguém fez o 2º pedido nos últimos 6 meses.</p>
    </div>
  </div>
</section>
